<template>
  <collapsed-card icon="md-stats" title="Статистика по проекту">
    <inline-loader :loading="loading" v-if="loading" />
    <div v-else class="contract-stats stats-block">
      <div class="contract-stats__row">
        <divider orientation="left">Сроки выполнения работ</divider>
        <dates-stats :stats="stats" />
      </div>
      <div class="contract-stats__row">
        <divider orientation="left">Акты</divider>
        <acts-stats :contract-page="true" :stats="stats" />
      </div>
      <div class="contract-stats__row">
        <divider orientation="left">Платежи</divider>
        <payments-stats :contract-page="true" :stats="stats" />
      </div>
    </div>
  </collapsed-card>
</template>

<script>
import CollapsedCard from '@/components/parts/collapsed-card'
import InlineLoader from '@/components/loaders/inline-loader'
import DatesStats from '@/components/stats/dates-stats'
import ActsStats from '@/components/stats/acts-stats'
import PaymentsStats from '@/components/stats/payments-stats'

export default {
  components: {
    CollapsedCard,
    InlineLoader,
    DatesStats,
    ActsStats,
    PaymentsStats
  },
  data () {
    return {
      stats: null,
      actStat: null,
      paymentStat: null,
      loading: false
    }
  },
  watch: {
    '$route.query.amendment_id': function (value) {
      console.log('reload stats --- ', value)
    }
  },
  methods: {
    async getData () {
      const { id } = this.$route.params

      try {
        this.loading = true
        const url = `page/project_stat/${id}`

        this.stats = await this.$store.dispatch('GET_REQUEST', { url })

        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="less">
.contract-stats {
  // padding-top: 8px;

  .ivu-divider {
    margin: 4px;
    margin-top: 12px;
  }
}
</style>
